import { render, staticRenderFns } from "./ExtraStaff.vue?vue&type=template&id=d673c36e&scoped=true&"
import script from "./ExtraStaff.vue?vue&type=script&lang=js&"
export * from "./ExtraStaff.vue?vue&type=script&lang=js&"
import style0 from "./ExtraStaff.vue?vue&type=style&index=0&id=d673c36e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d673c36e",
  null
  
)

export default component.exports